// MUI Components
import { Box } from '@mui/material';

// Contexts
import { useTheme } from '../../contexts/ThemeContext';


export default function GameContainer({ children, extendedWidth }) {
  const { theme } = useTheme();

  const paperSx = {
    bgcolor: theme.background.primary,
    borderRadius: 3,
    boxShadow: 6,
    p: { xs: 2, sm: 3 },
    maxWidth: 600,
    mx: 'auto',
    position: 'relative',
    minWidth: { xs: '90vw', sm: 550 },
    maxHeight: '80vh',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: '10px',
      height: '10px',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: theme.background.primary,
      borderRadius: '15px',
      border: `1px solid ${theme.border.light}`,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.scrollbar,
      borderRadius: '15px',
      cursor: 'grab',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: theme.scrollbarHover,
    },
    '&::-webkit-scrollbar-button': {
      display: 'none',
    },
  }

  return (
    <Box sx={{
      ...paperSx,
      ...(extendedWidth && { maxWidth: 900 })
    }}>
      {children}
    </Box>
  );
}
